// API
import { api } from '../configs/api/api';

// Models
import { IDashboardCharts, IDashboardTotals } from '../interfaces/dashboard.interfaces';
import dayjs from 'dayjs';

export const DashboardService = {
  fetchChartsInfo: async ({ date, worker_id }: { date?: string, worker_id?: number }): Promise<{
    error?: string,
    charts?: IDashboardCharts
  }> => {
    try {
      const axiosResponse = await api.get('/company/charts', {
        params: {
          ...(worker_id && { worker_id }),
          ...(date ? { date } : { date: dayjs().format('YYYY-MM-DD') }),
        }
      });
      return { charts: axiosResponse.data };
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
  fetchConsultationChartsInfo: async (): Promise<{ error?: string, totals?: IDashboardTotals }> => {
    try {
      const axiosResponse = await api.get('/company/consultation-charts');
      return { totals: axiosResponse.data };
    } catch (error: any) {
      const res = error?.response?.data;
      if (error?.response.status === 500) {
        return { error: res?.message };
      }
      return { ...res };
    }
  },
}
